import AuthenticationHelper from './authenticationHelper';
import goToS1 from './redirectionHelper';

export const AuthorizeComponent = component => {
  if (AuthenticationHelper.isJwtTokenStored()) {
    return component;
  } else {
    goToS1();
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/shared/helpers/authorizationHelper.js